import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    borderBottom: [1, 'solid', theme.palette.colors.divider],
    padding: [10, 0, 40],
    [theme.breakpoints.up('mobile')]: {
      padding: theme.spacing(4),
    },
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.colors.lightGray,
    },
  },
  mainBox: {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'space-between',
  },
  avatarBox: {
    display: 'flex',
    flexGrow: 1,
  },
  detailsBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    flexGrow: 7,
    marginLeft: theme.spacing(1),
    [theme.breakpoints.up('mobile')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  loanOfficerBadge: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  nmls: {
    color: theme.palette.colors.lightGray,
  },
  name: {
    margin: [4, 0],
  },
  companyLogoBox: {
    display: 'flex',
    justifyContent: 'end',
  },
  companyLogo: {
    height: 35,
    width: 'auto',
    maxWidth: 150,
  },
  tips: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    [theme.breakpoints.up('mobile')]: {
      alignItems: 'center',
    },
  },
  responseBadge: {
    display: 'inline-flex',
    color: theme.palette.colors.white,
    backgroundColor: theme.palette.colors.cornFlower,
    padding: [3, 6],
    borderRadius: 4,
    marginLeft: theme.spacing(1),
    overflow: 'hidden',
    width: 'fit-content',
    fontSize: 12,
  },
  thumbIcon: {
    fontSize: 12,
    color: theme.palette.colors.white,
    marginRight: 4,
  },
  helpedBadge: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.colors.alabaster,
    padding: [6, 12],
    borderRadius: 4,
    overflow: 'hidden',
    fontSize: 20,
  },
  helpLabel: {
    marginLeft: 5,
    lineHeight: '100%',
  },
  badgesBox: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    [theme.breakpoints.up('mobile')]: {
      marginTop: 'unset',
      marginRight: theme.spacing(2),
    },
  },
  tagsBox: {
    display: 'flex',
    width: '100%',
    justifyContent: 'start',
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      width: 'unset',
      justifyContent: 'unset',
    },
  },
  tag: {
    margin: [0, 4],
    '&:first-child': {
      marginLeft: 0,
    },
    '&:last-child': {
      marginRight: 0,
    },
  },
  label: {
    color: theme.palette.colors.darkGray,
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/LoanOfficerSelect/components/LoanOfficersList/components/LoanOfficerCard/useStyles.js